import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'core/store';

const agendaCommercialeReducer = (state: RootState) => state.private.agendaCommerciale;

export const agendaActionsSelector = createSelector(
  agendaCommercialeReducer,
  (agendaCommerciale) => agendaCommerciale.agendaActions
);

export const agendaActionsPagingSelector = createSelector(
  agendaCommercialeReducer,
  (agendaCommerciale) => agendaCommerciale.paging
);

export const filtersAgendaActionsUsedSelector = createSelector(
  agendaCommercialeReducer,
  (agendaCommerciale) => agendaCommerciale.filtersUsed
);

export const agendaFilterOptionsSelector = createSelector(
  agendaCommercialeReducer,
  (agendaCommerciale) => agendaCommerciale.filterOptions
);
